




























































import { Vue, Component } from 'vue-property-decorator'
import { ActionTypes } from '../store/modules/customer/types'
import ChoosePlan from '@/components/ChoosePlan.vue'
import * as PlanUtils from '../plugins/planUtils'

@Component({
    components: {
        ChoosePlan,
    },
})
export default class MyPageSwitchPlan extends Vue {
    product: { name: string; price: number; id: string; product_id: string } | null = null
    showPopup = false

    get package() {
        if (this.$store.state.customer.selectedProduct != null) {
            return this.$store.state.customer.selectedProduct.packageName
        } else {
            return 'original'
        }
    }
    set package(setPackage: string) {}
    async created(): Promise<void> {
        await this.$store.dispatch(ActionTypes.GET_PRODUCTS)
        if (this.$store.state.customer.userdata != null) {
            const option = this.$store.state.customer.userdata.option
            this.package = PlanUtils.getOptionName(option.id)
        } else {
            this.package = 'original'
        }
    }

    call(product: any): void {
        this.product = product
    }

    async onConfirmClicked(): Promise<void> {
        if (this.product) {
            const userdata_product_id = this.$store.state.customer.userdata.product_id
            const userdata_option_id = this.$store.state.customer.userdata.option.id
            const userdata_plan = this.$store.state.customer.userdata.plan
            if (
                userdata_plan &&
                this.product.product_id === userdata_product_id &&
                this.product.id === userdata_option_id
            ) {
                this.$store.commit(ActionTypes.SWITCH_PLAN_FAILTURE)
                this.showPopup = false
                return
            }
            this.$store.commit(ActionTypes.START_PAYMENT)
            try {
                await this.$store.dispatch(ActionTypes.SWITCH_PLAN_REQUEST, {
                    productId: this.product?.product_id,
                    option: {
                        id: this.product?.id,
                        name: this.product?.name,
                        price: this.product?.price,
                    },
                })
                await this.$store.dispatch(ActionTypes.GET_USERDATA)
                const tempProduct = PlanUtils.getPlanFormatToSaveFromUserdata(
                    this.$store.state.customer.userdata
                )
                this.$store.commit(ActionTypes.SAVE_OPTIONS, { product: tempProduct })
            } catch (e) {
                // TODO Error handling
                // eslint-disable-next-line no-console
                console.error(e)
            }
        }
        this.showPopup = false
    }
}
